import classNames from 'classnames';
import { INACTIVE } from '../../../../constants/components/pages/challenges/statuses';
import React from 'react';
import { useAccountMode } from '../../../../hooks/useAccountMode';
import { useQuestFlags } from '../../../../hooks/shared/quests/useQuestFlags';

export default function TaskItemWrapper({ quest, index, className, children }) {
  const { id, isEvent, questState, isComplete, premiumPrize } = quest;
  const { mode: accountMode } = useAccountMode();
  const { isChallenge } = useQuestFlags({ quest });

  return (
    <li
      key={`task-${id}`}
      className={classNames(
        'task__item',
        `task__item_${id}`,
        `task__item_${
          {
            premium: premiumPrize ? 'premium' : 'standard',
            standard: 'standard',
          }[accountMode]
        }`,
        {
          task__item_march: isEvent,
          task__item_completed: isComplete && !isChallenge,
          task__item_locked: questState === INACTIVE,
        },
        className,
      )}
      style={{ animationDelay: index * 0.05 + 0.2 + 's' }}
    >
      {children}
    </li>
  );
}
